<template>
  <div>
    <list-block>
      <el-form
        ref="formData"
        :inline="true"
        :rules="rules"
        :model="formData"
      >
        <h4 style="margin-bottom: 10px;">
          节点通用设置
        </h4>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="越库是否自动上架："
              prop="allowCrossDockingAndPutaway"
            >
              <el-radio-group
                v-model="formData.allowCrossDockingAndPutaway"
                :disabled="isDetail"
                @change="allowCrossDockingAndPutawayChange"
              >
                <el-radio
                  v-for="checkbox in BOOLEAN_STATE"
                  :key="checkbox.label"
                  :label="checkbox.value"
                >
                  {{ checkbox.label }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              v-if="formData.allowCrossDockingAndPutaway === BOOLEAN_STATE[0].value"
              label="越库自动上架库位："
              prop="autoPutawayStorehouseCode"
            >
              <el-select
                v-model="formData.autoPutawayStorehouseCode"
                placeholder="请选择"
                filterable
                :disabled="isDetail || warehouseFoundationList.disabled"
              >
                <el-option
                  v-for="item in warehouseFoundationList.option"
                  :key="item.locationCode"
                  :label="item.locationCode"
                  :value="item.locationCode"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="是否需要确认上架数量："
              prop="isConfirmPutawayAmount"
            >
              <el-radio-group
                v-model="formData.isConfirmPutawayAmount"
                :disabled="isDetail"
              >
                <el-radio
                  v-for="checkbox in BOOLEAN_STATE"
                  :key="checkbox.label"
                  :label="checkbox.value"
                >
                  {{ checkbox.label }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="是否扫描上架库位的容器："
              prop="isScanPutawayContainer"
            >
              <el-radio-group
                v-model="formData.isScanPutawayContainer"
                :disabled="isDetail"
              >
                <el-radio
                  v-for="checkbox in BOOLEAN_STATE"
                  :key="checkbox.label"
                  :label="checkbox.value"
                >
                  {{ checkbox.label }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 目的：整单回传与非越库库位同一行；单次上架回传独占下一行并左对齐在整单回传正下方（避免 inline 表单两项并排） -->
        <el-row>
          <el-col :span="12">
            <!-- 目的：「分批增量回传」不占用标签文案，用问号悬浮展示 -->
            <el-form-item prop="isEntireOrderNotify">
              <template slot="label">
                <span>
                  <el-tooltip content="选择否时，为分批增量回传；
                  注意：整单回传、分批增量回传、分批非增量回传只会有一种生效(分批非增量回传优先级最高)" placement="top"
                  >
                    <i
                      class="el-icon-question"
                      style="color: #909399; margin-right: 4px; cursor: help;"
                    />
                  </el-tooltip>
                  是否整单回传：
                </span>
              </template>
              <el-radio-group
                v-model="formData.isEntireOrderNotify"
                :disabled="isDetail || formData.isSingleListingNotify"
              >
                <el-radio
                  v-for="checkbox in BOOLEAN_STATE"
                  :key="checkbox.label"
                  :label="checkbox.value"
                >
                  {{ checkbox.label }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="非越库自动上架库位："
              prop="nonCrossPutawayStorehouseCode"
            >
              <el-select
                v-model="formData.nonCrossPutawayStorehouseCode"
                placeholder="请选择"
                filterable
                clearable
                remote
                :remote-method="getWarehouseLocation"
                :loading="targetLocationloadingSup"
                :disabled="isDetail"
                @change="handleNonCrossPutawayStorehouseCodeChange"
              >
                <el-option
                  v-for="item in nonCrossPutawayStorehouseCodeOption"
                  :key="item.storageLocationCode"
                  :label="item.storageLocationCode"
                  :value="item.storageLocationCode"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="分批非增量回传："
              prop="isSingleListingNotify"
            >
              <el-radio-group
                v-model="formData.isSingleListingNotify"
                :disabled="isDetail"
              >
                <el-radio
                  v-for="checkbox in BOOLEAN_STATE"
                  :key="checkbox.label"
                  :label="checkbox.value"
                >
                  {{ checkbox.label }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <TaskSetting
          ref="taskTableEl"
          :node-index="4"
          :table-data="formData.taskItemDetails"
        />
      </el-form>
    </list-block>
  </div>
</template>

<script>
import ListBlock from '@/components/ListBlock/index.vue';
import { tempStoreHouse, warehouseLocation } from '@/api/configure/warehousingProcess';

import TaskSetting from './TaskSetting.vue';
import {
  BOOLEAN_STATE,
  NODE_TYPE,
} from './constant';

export default {
  components: {
    ListBlock,
    TaskSetting,
  },
  props: {
    formData: {
      type: Object,
      default: () => {},
    },
    isDetail: {
      type: Boolean,
      default: false,
    },
    warehouseCode: {
      type: String,
      default: '',
    },
    warehouseId: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      BOOLEAN_STATE,
      warehouseFoundationList: {
        option: [],
        disabled: false,
      },
      nonCrossPutawayStorehouseCodeOption: [],
      targetLocationloadingSup: false,
      rules: {
        allowCrossDockingAndPutaway: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        autoPutawayStorehouseCode: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        isConfirmPutawayAmount: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        isScanPutawayContainer: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        isEntireOrderNotify: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        isSingleListingNotify: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
      },
    };
  },
  watch: {
    warehouseId: {
      immediate: true,
      handler(newVal, oldVal) {
        if (oldVal) {
          this.formData.autoPutawayStorehouseCode = null;
          this.formData.nonCrossPutawayStorehouseCode = null;
          this.formData.nonCrossPutawayStorehouseId = null;
        }
        if (newVal) {
          this.warehouseFoundationList = {
            disabled: false,
            option: [],
          };
          this.nonCrossPutawayStorehouseCodeOption = [];
          this.getStoreHouse();
          this.getWarehouseLocation();
        }
      },
    },
  },

  methods: {
    async getStoreHouse() {
      const res = await tempStoreHouse({
        warehouseId: this.warehouseId,
        typeCode: 'VIRTUAL_GOODS_AREA',
      }) || [];
      this.warehouseFoundationList.option = res;
      if (!this.formData.autoPutawayStorehouseCode) {
        const defaultVal = res.find((item) => item.isDefault);
        if (defaultVal) {
          this.formData.autoPutawayStorehouseCode = defaultVal.locationCode;
        }
      }
    },
    async getWarehouseLocation(query = '') {
      try {
        this.targetLocationloadingSup = true;
        const res = await warehouseLocation({
          storageLocationCode: query,
          warehouseCode: this.warehouseCode,
          statusCode: '1',
        });
        this.nonCrossPutawayStorehouseCodeOption = res.records;
      } finally {
        this.targetLocationloadingSup = false;
      }
    },
    handleNonCrossPutawayStorehouseCodeChange(code) {
      const findItem = this.nonCrossPutawayStorehouseCodeOption.find((item) => item.storageLocationCode === code);
      if (findItem) {
        this.formData.nonCrossPutawayStorehouseId = findItem.id;
      }
      if (!code) {
        this.getWarehouseLocation();
      }
    },
    allowCrossDockingAndPutawayChange(val) {
      if (!val) {
        this.$emit('resetStorehouseCode');
      }
    },
    // 纯获取数据
    getPureTableData() {
      return this.$refs.taskTableEl.getPureTableData();
    },
    // 重置任务下拉数据
    resetTaskOptions() {
      return this.$refs.taskTableEl.resetTaskOptions();
    },
    chooseGoodsPlace() {
      this.$emit('clearGoodsPlace');
    },
    validateForm() {
      /* eslint-disable-next-line */
      return new Promise(async (resolve) => {
        try {
          await this.$refs.formData.validate();
          const tableData = await this.$refs.taskTableEl.getTableData(4);
          resolve(tableData);
        } catch (error) {
          this.$message.warning(`请完善“${NODE_TYPE[4].label}”节点数据`);
        }
      });
    },
  },
};
</script>
